export default {
	
  common:{
	disabled:"禁用",
	normal:"正常",
	edit:"编辑",
	delete:"删除",
	tip:"提示",
	confirm:"确定",
	loading:"加载中...",
	
	cancel:"取消",
	nodata:"暂无数据",
	stop:"关闭",
	start:"开启",
	modify:"修改",
	submit:"提交",
	action:"操作",
	
	deleteSuccess:"删除成功",
	deleteCancel:"取消删除",
	editSuccess:"修改成功",
	
	save:"保存",
	saveSuccess:"保存成功",
	addSuccess:"添加成功",
	
	empty:"无",
	
	timeout:"网络超时",
	networkError:"网络连接错误",
	
	
	modalForm:"弹窗表单",
	
	
  },

  login: {
    
    usernameTip:"请输入用户名!",
    passwordTip:"请输入密码!",
	signIn:"马上登陆",
	copyright:"版权所有",
	successInfo:"登陆成功",
	
  },
  
  house:{
	  loadingTip:"加载中...",
	  state:"状态",
	  volume:"体积(m³)",
	  weight:"重量(吨)",
	  time:"时间",
	  stateUndone:"监测中",
	  stateDone:"已完成",
	  desc:"注：红色代表 X 轴. 绿色代表 Z 轴. 蓝色代表 Y 轴."   
  },
  
  home:{
	  
	  logout:"退出",
	  navigation:"系统导航",
	  copyright:"版权所有",
	  logoutTip:"退出成功!",
	  
  },
  
  user:{
	  
	  addUser:"新增用户",
	  inputUsername:"请输入用户名",
	  nodata:"暂无数据",
	  disabled:"禁用",
	  normal:"正常",
	  edit:"编辑",
	  changePassword:"修改密码",
	  delete:"删除",
	  editUser:"编辑用户",
	  deleteUser:"删除用户",
	  username:"用户名",
	  password:"密码",
	  fullName:"姓名",
	  role:"角色",
	  phoneNumber:"电话号码",
	  enabled:"是否启用",
	  action:"操作",
	  
	  usernameTip:"请输入用户名",
	  passwordTip:"请输入密码",
	  fullNameTip:"请输入姓名",
	  roleTip:"请选用户角色",
	  phoneTip:"请输入电话号码",
	  state:"状态",
	  stateTip:"请选择状态",
	  newPassword:"新密码",
	  newPasswordTip:"请输入新密码",
	  confirmPassword:"确认密码",
	  inputPasswordAgain:"请再次输入新密码",
	  
	  
	  tip:"提示",
	  deleteConfirm:"此操作会永久删除该用户,是否继续?",
	  confirm:"确定",
	  cancel:"取消",
	  userDeleteSuccess:"用户删除成功",
	  deleteCancel:"取消删除",
	  
	  
	  passwordDiffTip:"两次输入密码不一致",
	  
	  
	  editPasswordSuccess:"密码修改成功!",
	  addUserSuccess:"用户添加成功",
	  editSuccess:"修改成功",
	  userList:"人员列表",  
	   
  },
  
  timingTask:{
	  
	  schedule:"定时任务",
	  newSchedule:"新增任务",
	  orderByName:"按照名称排序",
	  inputBarnName:"请输入仓库编号",
	  chooseBarn:"选择仓库",
	  scheduleType:"任务类型",
	  hour:"小时",
	  minute:"分钟",
	  desc:"备注",
	  inputDesc:"请输入任务备注",
	  editSchedule:"修改任务",
	  day:"天",
	  scheduleId:"任务ID",
	  barnId:"仓库编号",
	  state:"任务状态",
	  startSuccessTip:"任务开启成功",
	  stopSuccessTip:"任务关闭成功",
	  deleteConfirm:"此操作会永久删除这个任务,是否继续?",
	  addSuccessTip:"任务添加成功",  
	  
  },
  
  systemManagement:{

	//仓长(cm)
	warehouseLength:"仓长(cm)",
	inputWarehouseLength:"请输入仓长",

	//仓宽(cm)
	warehouseWidth:"仓宽(cm)",
	inputWarehouseWidth:"请输入仓宽",

	//仓高(cm)
	warehouseHeight:"仓高(cm)",
	inputWarehouseHeight:"请输入仓高",

	//上锥选择
	warehouseTopCone:"上锥选择",
	hasTopCone:"是否有上锥",
	yes:"有",
	no:"无",
	//请选择是否具有上锥
	selectTopCone:"请选择是否具有上锥",
	//下锥选择
	warehouseLowerCone:"下锥选择",
	hasLowerCone:"是否有下锥",

	//上锥高度(cm)
	warehouseTopConeHeight:"上锥高度(cm)",
	inputWarehouseTopConeHeight:"请输入上锥高度",

	//端口
	warehousePort:"端口",
	inputWarehousePort:"请输入端口",

	//地址位
	warehouseAddress:"地址位",
	inputWarehouseAddress:"请输入地址位(1-255)",

	//定时扫描(min)
	warehouseScanTime:"定时扫描(min)",
	inputWarehouseScanTime:"请输入定时扫描间隔（分钟，传0或者则不传不执行）",

	//定点扫描
	warehouseFixedScan:"定点扫描",
	inputWarehouseFixedScan:"请输入定点扫描时间（hh:mm:ss）",

	//ip地址
	warehouseIP:"ip地址",
	inputWarehouseIP:"请输入ip地址",
	  
	  barnInfo:"仓房信息",
	  barnType:"仓房类型",
	  cubeBarn:"平方仓",
	  cylinderBarn:"圆筒仓",
	  hemisphereBarn:"半圆仓",
	  cubeLength:"方仓长(cm)",
	  inputCubeLength:"请输入方仓长度",
	  cubeWidth:"方仓宽(cm)",
	  inputCubeWidth:"请输入方仓宽度",
	  cubeHeight:"方仓高(cm)",
	  inputCubeHeight:"请输入方仓高",
	  grainDensity:"粮密度(kg/m³)",
	  inputGrainDensity:"请输入粮密度",
	  probeAxisX:"探头坐标X(cm)",
	  inputProbeAxisX:"请输入探头坐标X",
	  probeAxisY:"探头坐标Y(cm)",
	  inputProbeAxisY:"请输入探头坐标Y",
	  probeAxisZ:"探头坐标Z(cm)",
	  inputProbeAxisZ:"请输入探头坐标Z",
	  cylinderRadius:"筒仓半径(cm)",
	  inputCylinderRadius:"请输入筒仓半径",
	  cylinderHeight:"筒仓高度(mm)",
	  inputCylinderHeight:"请输入筒仓高度，无上锥时为0",
	  higherCone:"筒仓上锥高度(mm)",
	  inputHigherCone:"请输入筒仓上维高度,无上锥时为0",
	  lowerCone:"筒仓下锥高度(mm)",
	  inputLowerCone:"请输入筒仓下锥高度，无下锥时为0",
	  lowerConeRadius:"筒仓下锥半径(cm)",
	  inputLowerConeRadius:"请输入筒仓下锥半径",
	  lowerHoleRadius:"下锥出料口半径(cm)",
	  inputLowerHoleRadius:"请输入下锥出料口半径",
	  boundaryGap:"边界判定间隙(cm)",
	  inputBoundaryGap:"请输入边界判定间隙，默认50cm",
	  volumeCheck:"体积补偿校准(0.1m³)",
	  inputVolumeCheck:"请输入体积补偿校准",
	  areaCheck:"面积补偿校准(0.1㎡)",
	  inputAreaCheck:"请输入面积补偿校准",
	  minimumAngle:"最小步进角度(0.1°)",
	  inputMinimumAngle:"请输入最小步进角度",
	  maximumAngle:"最大步进角度(0.1°)",
	  inputMaximumAngle:"请输入最大步进角度",
	  editPorbeIP:"修改探头IP",
	  inputPort:"请输入网口",
	  inputIp:"请输入IP",
	  gateway:"网关",
	  inputGateway:"请输入网关",
	  broadcast:"广播地址",
	  inputBroadcast:"请输入广播地址",
	  readSuccess:"读取成功",
	  
	  
	  installAngle:"安装角度",
	  horizontal:"水平角度(°):",
	  vertical:"垂直角度(°):",
	  angleAdjust:"角度校准",
	  readParams:"读取参数",
	  saveParams:"保存参数",
	  
	  searchDevices:"设备搜索",
	  ipScope:"ip范围：",
	  portNumber:"端口号：",
	  
	  searchSuccess:"搜索成功",
	  searchFail:"搜索失败,请确认ip格式或设备是否在线！",
	  
	  
	  
	  
  },

  
  warehouseInfo:{

	  //异常数据
	  exceptionData:"异常数据",

	  //异常监测开关
	  exceptionMonitor:"异常监测开关",
	  //请选择是否启动异常监测
	  exceptionMonitorTip:"请选择是否启动异常监测",

	  //API开关
	  apiStatus:"API开关",
	  //请选择是否开启API
	  apiStatusTip:"请选择是否开启API",
	  //API端口
	  apiPort:"API端口",
	  //请输入API端口（纯数字，非必填）
	  apiPortTip:"请输入纯数字的API端口",

	  //高度阈值(米)
	  threshold:"高度阈值(米)",
	  inputThreshold:"请输入高度阈值(米)",
	  //最小异常面积(㎡)
	  minArea:"最小异常面积(㎡)",
	  inputMinArea:"请输入最小异常面积(㎡)",
	  //网格分辨率(米)
	  gridResolution:"网格分辨率(米)",
	  inputGridResolution:"请输入网格分辨率(米)",
	  //探头臂长(米)
	  probeArmLength:"探头臂长(米)",
	  inputProbeArmLength:"请输入探头臂长(米)",
	  //探头X坐标(米)
	  probeAxisX:"探头坐标X(米)",
	  inputProbeAxisX:"请输入探头坐标X(米)",
	  //探头Y坐标(米)
	  probeAxisY:"探头坐标Y(米)",
	  inputProbeAxisY:"请输入探头坐标Y(米)",
	  //探头Z坐标(米)
	  probeAxisZ:"探头坐标Z(米)",
	  inputProbeAxisZ:"请输入探头坐标Z(米)",

	  //

	  //坐标调试
	  coordinateDebug:"坐标调试",
	  
	  
	  barnList:"所有库房",
	  addBarn:"新增仓房",
	  inputBarnNumber:"请输入仓库编号",
	  radarConfig:"雷达配置",
	  radarParamConfig:"雷达参数配置",
	  restartDevice:"设备重启",
	  editBarn:"编辑库房",
	  barnNumber:"仓库编号",
	  barnName:"仓库名称",
	  barnType:"仓型",
	  keeper:"保管员",
	  inputBarnName:"请输入库房名称",
	  chooseBarnType:"请选择仓库类型",
	  cubeBarn:"平方仓",
	  cylinderBarn:"圆筒仓",
	  modelingType:"建模选择",
	  chooseModelingType:"请选择建模结构",
	  originalPoints:"原始点",
	  fill:"填充",
	  chooseStructure:"请选择仓库结构",
	  barnLenght:"方仓长/筒仓直径(cm)",
	  inputBarnLength:"请输入方仓长/筒仓直径",
	  barnWidth:"方仓宽/筒仓下锥高(cm)",
	  inputBarnWidth:"请输入方仓宽/筒仓下锥高",
	  barnHeight:"方仓高/筒仓高(cm)",
	  inputBarnHeight:"请输入方仓高/筒仓高",
	  barnConeHeight:"方仓下锥高(cm)",
	  inputBarnConeHeight:"请输入方仓下锥高",
	  //方仓下锥
	  fcConeHeight:"方仓下锥口长(cm)",
	  inputFcConeHeight:"请输入方仓下锥口长度",
	  //方仓下锥宽
	  fcConeWidth:"方仓下锥口宽(cm)",
	  inputFcConeWidth:"请输入方仓下锥口宽度",
	  chooseKeeper:"请选择保管员",
	  planVolume:"设计仓容(m³)",
	  inputPlanVolume:"请输入设计仓容",
	  actualVolume:"实际仓容(m³)",
	  inputActualVolume:"请输入实际仓容",
	  deviceType:"盘点设备类型",
	  inputDeviceType:"请选择盘点设备类型",
	  v2:"设备2.0",
	  v1:"设备1.0",
	  grainType:"粮食类型",
	  chooseGrainType:"请选择存放粮食类型,如玉米",
	  corn:"玉米",
	  wheat:"小麦",
	  sorghum:"高粱",
	  rice:"水稻",
	  bean:"大豆",
	  paddy:"大米",
	  millet:"小米",
	  other:"其他",
	  dedusting:"除尘功能",
	  chooseDedusting:"请选择是否具有除尘功能",
	  yes:"有",
	  no:"无",
	  axisX:"设备坐标x",
	  inputAxisX:"请输入x轴坐标",
	  axisY:"设备坐标y",
	  inputAxisY:"请输入y轴坐标",
	  axisZ:"设备坐标z",
	  inputAxisZ:"请输入z轴坐标",
	  inputIP:"请输入IP",
	  deviceIP:"设备IP",
	  inputDeviceIP:"请输入设备IP",
	  devicePort:"设备端口",
	  inputDevicePort:"请输入设备端口",
	  username:"用户名",
	  inputUsername:"请输入用户名",
	  password:"密码",
	  inputPassword:"请输入密码",
	  sshPort:"SSH端口",
	  inputSshPort:"请输入SSH端口",
	  deviceRestartSuccess:"设备重启成功",
	  deleteBarnTip:"此操作会永久删除这个仓库,是否继续?",
	  radarConfigSuccess:"雷达配置成功",
	  
	  
	  
	  
	  getPoints:"获取点位",
	  cubeParams:"方仓参数：",
	  cubeLength:"方仓长cm：",
	  cubeWidth:"方仓宽cm：：",
	  cubeHeight:"方仓高cm：",
	  cubeCone:"下锥高cm：",
	  cylinderParams:"筒仓参数：",
	  cylinderHeight:"筒仓高mm：",
	  cylinderCone:"上锥高mm：",
	  cylinderRadius:"下锥半径cm：",

	  //筒仓半径cm
	  cylinderRadius1:"筒仓半径cm：",
	  //筒仓高mm：
	  cylinderHeight1:"筒仓高mm：",
	  //上锥高mm：
	  cylinderCone1:"上锥高mm：",
	  //下锥高mm：
	  cylinderConeDown1:"下锥高mm：",
	  //筒仓下锥半径cm：
	  cylinderRadiusDown1:"下锥半径cm：",
	  
	  //筒仓形状
	  cylinderShape:"筒仓形状",
	  chooseCylinderShape:"请选择筒仓形状",
	  bothCones:"有上下锥",
	  onlyTopCone:"只有上锥",
	  onlyBottomCone:"只有下锥",
	  noCones:"无上下锥",
	  
	  //探头坐标：
	  probeCoordinates:"探头坐标",

	  //X坐标
	  probeAxisX:"X坐标",
	  //Y坐标
	  probeAxisY:"Y坐标",
	  //Z坐标
	  probeAxisZ:"Z坐标",

	  //安装角度
	  probeInstallAngle:"安装角度",

	  //水平角度
	  probeHorizontalAngle:"水平角度",
	  //垂直角度
	  probeVerticalAngle:"垂直角度",
	  //角度校准
	  probeAngleCalibration:"角度校准",
	  //读取参数
	  probeReadParameter:"读取参数",
	  //保存参数
	  probeSaveParameter:"保存参数",

    alarmFunction:"报警功能",
    checkFunction:"是否有无报警功能",
    grainDensity:"粮密度(kg/m³)",
    grainDensityInput:"请输入粮食密度,初始值为1",
    property:"库存性质",
    propertyInput:"请输入库存性质,如市级储备粮",

    harvestYear:"收获年度",
    harvestYearInput:"请输入收获年度,如2022",
    level:"等级",
    levelInput:"请输入等级,如二等",
    validity:"有效性(%)",
    validityInput:"请输入有效性百分比",
  },
  
  system:{

      screenShowBarn:"大屏展示仓库",
      chooseBarn:"请选择仓库",
      checkPushAddress:"盘点推送地址",
      inputCheckPushAddress:"请输入盘点推送地址",
      scanPushAddress:"扫描推送地址",
      inputScanPushAddress:"请输入扫描推送地址",
      exceptionPushAddress:"异常推送地址",
      inputExceptionPushAddress:"请输入异常推送地址",
      sensorPushAddress:"线缆数据推送地址",
      inputSensorPushAddress:"请输入线缆数据推送地址",
      companyLogo:"公司logo",
      upload:"上传",
      systemName:"系统名称",
      inputSystemName:"请输入系统名称",
      companyName:"公司名称",
      inputCompanyName:"请输入公司名称",
      versionNumber:"版本号",
      inputVersionNumber:"请输入版本号",
      inputCompanyLogo:"请上传公司logo",
      pointCloudPath:"点云文件路径",
      inputPointCloudPath:"请输入点云文件路径",
  },
  
  rbac:{
	  
	  authorization:"授权",
	  grantPermission:"分配权限",
	  screen:"大屏展示",
	  homePage:"首页",
	  detection:"检测控制",
	  historicalData:"历史数据",
	  history:"历史记录",
	  alarmRecord:"报警记录",
	  barnList:"仓房信息",
	  cameraManage:"摄像头管理",
	  userManage:"用户管理",
	  schedule:"定时任务",
	  systemManage:"系统配置",
	  permissionManage:"权限管理",
	  roleManage:"角色管理",
	  menuManage:"菜单管理",
	  chooseMenuItem:"请至少选择一个菜单！",
	  grantSuccess:"授权成功",
	  login:"登录",
	  barnDisplay:"粮仓展示",

    singleBarnDisplay:"单仓显示",
    playback:"历史录像",
    cameraView:"摄像头画面",
    radarConfig:"雷达详细配置",
	  
	  
	  addMenu:"新增菜单",
	  editMenu:"编辑菜单",
	  menuName:"菜单名称",
	  menuType:"菜单类型",
	  permissionID:"权限标识",
	  visitPath:"访问路径",
	  orderID:"排序号",
	  icon:"图标",
	  parentMenu:"父级菜单",
	  chooseParentMenu:"请选择父级菜单",
	  inputMenuName:"请输入菜单名称",
	  inputPermissionID:"请输入权限标识",
	  inputVisitPath:"请输入访问路径",
	  inputOrderID:"请输入排序号",
	  inputNumberTip:"请输入1~100之间的数字",
	  inputIcon:"请输入图标",
	  deleteTip:"此操作会永久删除该菜单,是否继续?",
	  deleteMenuSuccess:"菜单删除成功",
	  addMenuSuccess:"菜单添加成功",
	  menuList:"菜单列表",
	  empty:"无",
	  
	  
	  addRole:"新增角色",
	  editRole:"编辑角色",
	  roleName:"角色名称",
	  roleID:"角色标识",
	  roleDesc:"角色描述",
	  admin:"管理员",
	  inputRoleName:"请输入角色名称",
	  inputRoleID:"请输入角色标识",
	  inputRoleDesc:"请输入角色描述",
	  deleteRoleTip:"此操作会永久删除该角色,是否继续?",
	  deleteRoleSuccess:"角色删除成功",
	  addRoleSuccess:"角色添加成功",
	  
  },
  
  detection:{
    //历史数据
    historyData:"历史数据",
    //历史曲线
    historyCurve:"历史曲线",
	//温度(℃)
	temperature:"温度(℃)",
	//湿度(%)
	humidity:"湿度(%)",


	//库存数量(吨)
	stockQuantity:"库存数量(吨)",
	//检测数量
	detectionQuantity:"检测数量(吨)",
	//差异数量(吨)
	differenceQuantity:"差异数量(吨)",
	//差异率(%)
	differenceRate:"差异率(%)",

	//待补仓数量(吨)
	differenceQuantity:"待补仓数量(吨)",

	//未记账数量(吨)：
	differenceQuantity:"未记账数量(吨)：无",

	//粮面平整度
	grainSurfaceFlatness:"粮面平整度：正常",

	//粮面异动
	grainSurfaceDeviation:"粮面异动：无",

	//仓房基本信息
	barnBasicInfo:"仓房基本信息",
	//仓房名称
	barnName:"仓房名称",
	//物料种类
	grainType:"物料种类",


	  
	  online:"在线",
	  offline:"离线",
	  barnID:"仓库编号",
	  stock:"库存",
	  ton:"吨",
	  stockVolume:"库存体积",
	  stockWeight:"库存重量",
	  grainType:"粮食种类",

    singleHeight:"料高",
	  
	  
	  alarmLogs:"报警记录",
	  start:"开始时间",
	  end:"结束时间",
	  all:"全部",
	  magneticAlarm:"门磁报警",
	  infraredAlarm:"红外报警",
	  helpAlarm:"呼救报警",
	  inputBarnID:"请输入仓库编号",
	  exportExcel:"导出报表",
	  clearAlarm:"清除报警",
	  alarmInfo:"报警信息",
	  alarmTime:"报警时间",
	  clearSuccess:"清除报警成功",
	  clearFail:"清除报警失败",
	  deteleAlarmSuccess:"此操作会永久删除这条记录,是否继续?",
	  
	  
	  historicalData:"历史数据",
	  loading:"加载中...",
	  validPoints:"有效测试点数量：",
	  operator:"操作人：",
	  status:"状态：",
	  checking:"检测中",
	  done:"已完成",
	  deviceOffline:"设备离线",
	  scanFailed:"扫描失败",
	  validCheck:"有效性判断：",
	  valid:"有效",
	  invalid:"无效",
	  errorCode:"错误标识：",
	  volume1:"体积(m³)：",
	  height:"等效高度(m)：",
	  averageHeight:"平均高度(m)：",
	  highestPoint:"最高点(m)：",
	  lowestPoint:"最低点(m)：",
	  scanTimes:"盘库计数：",
	  datetime:"时间：",
	  scanType:"扫描方式：",
	  auto:"自动",
	  manual:"手动",
	  validScanPoints:"有效扫描点数：",
	  probeError:"探头错误：",
	  normal:"正常",
	  error:"错误",
	  weight:"重量(吨)：",
	  defenceState:"布防状态：",
	  defend:"布防",
	  undefend:"撤防",
	  alarm:"报警",
	  alarmState:"报警状态：",
	  infraredDefendState:"红外布防状态：",
	  infraredAlarmState:"红外报警状态：",
	  helpAlarmState:"呼救报警状态：",
	  desc:"注：3D视图中红色代表 X 轴. 绿色代表 Z 轴. 蓝色代表 Y 轴.",
	  
	  
	  singleBarnDisplay:"单仓显示",
	  collectionProgress:"采集进度",
	  startScan:"开始扫描",
	  stopScan:"停止扫描",
	  queryState:"查询状态",
	  clearDust:"清除扫尘",
	  historicalDataRecord:"历史数据记录",
	  threeD:"三维展示",
	  downloading:"正在下载数据...",
	  offlineTip:"设备不在线!请检查设备是否正常!",
	  operateSuccess:"操作成功",
	  operateFail:"操作失败",
	  browserCheckTip:"您的浏览器不支持WebSocket",
	  idle:"空闲中...",
	  scanning:"正在扫描...",
	  scanFailTip:"扫描失败，错误码",
	  scanDone:"扫描完成",
	  scanException:"扫描异常!",
    deviceOff:"设备离线...",
	  loadingData:"正在加载数据...",
	  scanPause:"扫描暂停",
	  scanningTip:"正在扫描中",
	  magneticDefend:"门磁布防：",
	  on:"开",
	  off:"关",
	  magneticAlarmState:"门磁报警状态：",
	  infraredDefend:"红外布防：",
	  
	  
	  detection:"检测控制",
	  selectOrder:"选择排序：",
	  orderByTime:"按创建时间",
	  orderByName:"按名称",
	  orderByOnline:"按在线",
	  orderByOffline:"按离线",
	  inputBarnID:"请输入仓库编号",
	  invertSelect:"反选",
	  allSelect:"全选",
	  scanControl:"控制扫描",
    measureControl:"测距控制",
	  chooseBarnTip:"请选择至少一个仓",
	  
	  
	  
	  dataRecord:"数据记录",
	  barnVolume:"仓容(m³)",
	  detectStart:"监测开始时间",
	  detectEnd:"监测结束时间",


    detectionInfo:"检测信息",
    amount:"检测数量(吨)",
    barnInfo:"仓房基本信息",
    barnType:"仓房类型",
    volume:"容量(m³)",
    variety:"品种",
    property:"库存性质",
    harvestYear:"收获年度",
    level:"等级",


	//数据(m)
	data:"数据(m)",
	//错误码
	errorCode:"错误码",
	//状态码
	statusCode:"状态码",

	//远程控制
	remoteControl:"远程控制",

	//测距
	measure:"测距",

	//扫描筛选
	scanFilter:"扫描筛选",

	//timing
	timing:"定时",
	//定点
	point:"定点",

	//日报表
	report:"日报表",
	//周报表
	weekReport:"周报表",
	//月报表
	monthReport:"月报表",

	//历史曲线
	historicalCurve:"历史曲线",

	//选择仓房
	selectBarn:"选择仓房",
	//搜索
	search:"搜索",

	//数据(mm)
	dataMM:"数据(mm)",

	//测量时间
	measureTime:"测量时间",

	//请至少选择一条记录进行删除！
	selectRecordDelete:"请至少选择一条记录进行删除！",
	//请选择一个仓房！
	selectBarnTip:"请选择一个仓房！",


    monitor:"视频监控",

    reports:"报表生成",

    // 粮食实物检查工作底稿表
    grainInspectionReport:"粮食实物检查工作底稿表",
    companySeal:"企业（盖章）：",
    measurementDate:"测量日期：",
    cargoLocation:"货位号",
    grainType:"品种",
    nature:"性质",
    harvestYear:"收获年度",
    storageForm:"储存形式",
    accountQuantity:"保管账数(kg)",
    qualityGrade:"质量等级",
    entryMethod:"入仓方式",
    grainBarn:"粮仓",
    entrustedStorage:"是否受托储粮",
    grainInboundQuality:"粮食入库质量",
    bulkDensity:"容重(g/l)(出糙率 纯粮率%)",
    measuredGrainQuality:"实测粮食质量",
    moisture:"水分(%)",
    impurity:"杂质(%)",
    calculateGrainVolume:"1.计算粮堆体积",
    grainShapeDimensions:"粮堆形状及基本尺寸",
    chart:"（图）",
    measuredGrainVolume:"粮堆测量体积（m³）",
    deductVolume:"需要扣除体积（m³）",
    actualGrainVolume:"粮堆实际体积（m³）",
    calculateAvgDensity:"2.计算粮堆平均密度",
    standardContainerMethod:"标准容器法□",
    grainBulkDensity:"粮食容重",
    correctedFactor:"校正后修正系数",
    avgGrainDensity:"粮堆平均密度",
    specialContainerMethod:"特制大容器法□",
    unitVolumeWeight:"单位体积粮食重量",
    kgPerCubicMeter:"（kg/m³）",
    calculateGrainQuantity:"3.计算粮食数量",
    confirmActualQuantity:"4.认定粮食实际数量",
    calculatedQuantity:"测量计算数（kg）",
    compareWithAccount:"检查计算数与保管数比较",
    difference:"差数（kg）",
    lossRate:"差率（%）",
    grainLoss:"应计粮食损耗（kg）",
    moistureLoss:"水分减量",
    storageLoss:"保管自然损耗",
    total:"合计",
    accountMatch:"账实是否相符",
    no:"否",
    actualGrainQuantity:"粮食实际数量（kg）",

    validity:"有效性(%)",
    isValid:"是否有效",

    temperature:"温度",
    humidity:"湿度",

    // 库存统计表
    stockStatistics:"库存统计表",
    stockList:"库存列表",
    inputBarnName:"请输入仓房名称",
    materialName:"原料名称",
    grainType:"粮食种类",
    stockVolume:"库存体积(m³)",
    scanTime:"扫描时间",
    exportSuccess:"导出成功",
    viewDetail:"查看详情",

    // 变动统计
    changeStatistics:"变动统计",
    changeList:"变动记录列表",
    allTypes:"全部类型",
    changeType:"变动类型",
    changeDensity:"修改密度",
    changeGrainType:"修改粮食种类",
    barnOffline:"仓房离线",
    beforeValue:"变动前",
    afterValue:"变动后",
    operator:"操作人",
    changeTime:"变动时间",
    remark:"备注",

    // 大屏分类重量统计
    categoryWeightStats:"分类重量统计",
    onlineOfflineStats:"在线/离线统计",
    weightTrend:"重量趋势",
    unknown:"未知",
    ton:"吨",

    // 大屏网格组件
    stockPercent:"库存百分比",
    materialType:"物料种类",

	 
	  
  },
  
  historicalVideo:{
	  
	  playback:"历史录像",
	  chooseTime:"选择时间：",
	  chooseStart:"请选择开始时间",
	  chooseEnd:"请选择结束时间",
	  query:"查询",
	  loading:"数据加载中...",
	  start:"开始时间：",
	  end:"结束时间：",
	  
  },
  
  camera:{
	  
	  pictureLoading:"画面加载中...",
	  ptzControl:"云台控制",
	  focalLength:"焦距",
	  lensMove:"画面移动",
    brand:"品牌",
	  
	  login:"登录",
	  preview:"预览",
	  start:"开始时间",
	  end:"结束时间",
	  playback:"回放",
	  loginSuccess:"登录成功",
	  loginFail:"登录失败，请检查IP、端口、用户名和密码是否正确！",
	  missingDeviceInfo:"请先填写设备IP和端口！",
	  notLogin:"请先登录设备！",
	  noChannel:"未获取到视频通道，请稍候或重新登录！",
	  getChannelFail:"获取视频通道失败！",
	  selectTimeRange:"请选择回放的开始和结束时间！",
	  previewSuccess:"预览成功",
	  previewFail:"预览失败，请检查是否登录！",
	  supportWebsockitTip:"设备不支持Websocket取流，请在浏览器访问该设备ip进行查看！",
	  startPlaybackSuccess:"开始回放成功！",
	  notSupportWebsockit:"设备不支持Websocket取流！",
	  startPlaybackFail:"开始回放失败！",
	  
	  
	  addCamera:"新增摄像头",
	  inputBarnID:"请输入仓库编号",
	  pictureCheck:"画面查看",
	  editCamera:"编辑摄像头",
	  barnID:"仓库编号",
	  type:"类型",
	  name:"名称",
	  linkType:"连接方式",
	  username:"用户名",
	  password:"密码",
	  barn:"仓库",
	  chooseBarn:"请选择仓库",
	  deviceType:"设备类型",
	  chooseDeviceType:"请选择设备类型",
	  camera:"摄像头",
	  vcr:"硬盘录像机",
	  chooseLinkType:"请选择连接方式",
	  ez:"萤石云",
	  localNet:"局域网",
	  inputName:"请输入名称",
	  inputUsername:"请输入用户名",
	  inputPassword:"请输入密码",
	  ipAddr:"IP地址",
	  inputIpAddr:"请输入ip地址",
	  port:"端口号",
	  inputPort:"请输入端口号",
	  deleteCameraTip:"此操作会永久删除该摄像头,是否继续?",
	  deleteSuccess:"摄像头删除成功",
	  addSuccess:"摄像头添加成功",
	  
	  
  },
  
  
  screen:{
	  
	  
	  totalStorage:"存储总量",
	  id:"序号",
	  barnID:"仓号",
	  volume:"体积",
	  start:"开始时间",
	  end:"结束时间",

    lgz:"料高",
    weight:"重量",
    weightSingle:"重量(吨)",
	  
	  
	  entrySystem:"进入系统",
	  curTotalStorage:"当前存储总量(吨)",
	  totalDevices:"在线/离线统计(%)",
	  storageChange:"存储总量变化(方)",
	  dynamicData:"动态数据表",
	  useRatio:"当前储量及利用率",
	  
  },
  
  components:{
	  
	  outline:"外框",
	  reset:"复位",
    heatmap:"热力图",
    grainPlane:"粮面",
    pointCloud:"点云",
	//俯视图
    topView:"俯视图",
	//显示仓房外框
    outline:"显示仓房外框",
	//层级过滤
    layerFilter:"层级过滤",
	//层级过滤
    layer:"层",
	//查看全部
    viewAll:"查看全部",
	//线缆-传感器列表
    sensorList:"线缆-传感器列表",
	//仓库信息
    warehouseInfo:"仓库信息",
	//仓号
    warehouseID:"仓号",
	//平均湿度
    averageHumidity:"平均湿度",
	//平均水分
    averageMoisture:"平均水分",

	//粮食种类
    foodType:"粮食种类",

	//无数据
    noData:"无数据",

	//温度上限
    temperatureUpperLimit:"温度上限",
	//温度下限
    temperatureLowerLimit:"温度下限",
	//温度超限
    temperatureExceeded:"温度超限",
	//水分上限
    humidityUpperLimit:"水分上限",
	//水分下限
    humidityLowerLimit:"水分下限",
	//水分超限
    humidityExceeded:"水分超限",

	//正常范围内
    normalRange:"正常范围内",
	//超出上下限但在超限值内
    exceededRange:"超出上下限但在超限值内",
	//超出超限值
    exceededLimit:"超出超限值",
	//选中状态
    selected:"选中状态",

	//超出上下限
    exceededRange1:"超出上下限",
	//正常
    normal:"正常",

	//最高水分
    highestMoisture:"最高水分",
	//最低水分
    lowestMoisture:"最低水分",
	//最高温度
    highestTemperature:"最高温度",
	//最低温度
    lowestTemperature:"最低温度",

	//采集时间
    collectTime:"采集时间",
	//传感器详情
    sensorDetail:"传感器详情",
	//缆号
    cableID:"缆号",
	//传感号
    sensorID:"传感号",
	//温度
    temperature:"温度",
	//水分
    moisture:"水分",
	//M值
    mValue:"M值",
	//缆号/传感号
    cableSensorID:"缆号/传感号",
	//缺少仓库ID参数
	missingWarehouseID:"缺少仓库ID参数",
	//获取仓库数据失败
    getWarehouseDataFailed:"获取仓库数据失败",
	//获取仓库数据出错
	getWarehouseDataError:"获取仓库数据出错",

	//至少需要选择一个层级
    atLeastOneLayer:"至少需要选择一个层级",

	//初始化3D视图出错
    init3DViewError:"初始化3D视图出错",
  },
  
  //消息提示
  message:{
    setLanguageSuccess:"设置语言成功"
  },
  //菜单相关
  menus:{
    deviceManage:"设备管理"
  }
}
